import BaseRepository from '@/api/repositories/BaseRepository';

export default class AdminSystemSettingsRepository extends BaseRepository {
	getAll() {
		return this.get(`admin-system-settings`, {});
	}

	updateAll(data) {
		return this.put(`admin-system-settings`, {}, data);
	}
}
